/* Image-first: the picture is the card, and the text sits under it on the page itself.
   The old boxed card (border, raised fill, lift on hover) made every row of the site look
   like the same component. */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}
.media {
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-lg);
}
.media img {
  transition: transform 600ms var(--ease);
}
.card:hover .media img {
  transform: scale(1.04);
}
/* The stretched link covers the whole card, so its focus ring is drawn on the picture. */
.card:has(.link:focus-visible) .media {
  outline: 3px solid var(--focus);
  outline-offset: 3px;
}
.placeholder {
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--surface-hover), var(--surface-alt));
  border: 1px solid var(--border);
  color: var(--text-muted);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: var(--fs-lg);
}
.body {
  display: grid;
  gap: var(--sp-2);
}
.kindRow {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--sp-2) var(--sp-4);
  margin: 0;
  font-size: var(--fs-sm);
}
.kind {
  font-weight: 600;
  color: var(--accent-text);
}
.meta {
  color: var(--text-muted);
}
.title {
  font-size: var(--fs-xl);
  line-height: var(--lh-snug);
}
.link {
  color: inherit;
  text-decoration: none;
  transition: color var(--dur) var(--ease);
}
.link:focus-visible {
  outline: none;
}
.link::after {
  /* whole card is clickable, without nesting interactive elements */
  content: "";
  position: absolute;
  inset: 0;
}
.card:hover .link {
  color: var(--accent-text);
}
.description {
  margin: 0;
  color: var(--text);
}

/* ---- variants for a 1 + 2 layout ---------------------------------------- */
.feature .title {
  font-size: clamp(var(--fs-xl), 1rem + 1vw, var(--fs-3xl));
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-heading);
}
.feature .description {
  max-width: 44rem;
  font-size: var(--fs-md);
}
.compact {
  display: grid;
  grid-template-columns: minmax(7rem, 2fr) 3fr;
  align-items: center;
  gap: var(--sp-5);
}
.compact .title {
  font-size: var(--fs-lg);
}
